import moment from 'moment';
import type {GridColDef, GridActionsColDef} from '@mui/x-data-grid';
import type {Member} from 'api/v2';
import {Typography} from '@wellstone-solutions/web';
import {NavigationCell, ProgramCell} from 'modules/datagrid';
import {adminRoles} from 'utils/Forms';
import {RemoveStaffButton} from './RemoveStaffButton';
import {StaffProfileCell} from './StaffProfileCell';

interface StaffListColumns {
  name: GridColDef<Member>;
  role: GridColDef<Member>;
  lastLogin: GridColDef<Member>;
  ehr: GridColDef<Member>;
  programs: GridColDef<Member>;
  mobile: GridColDef<Member>;
  actions: GridActionsColDef<Member>;
}

export const staffListColumns: StaffListColumns = {
  name: {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
    renderCell: ({row}) => (
      <NavigationCell to={`/staff/${row.id}`} text={row.name} />
    ),
  },
  role: {
    field: 'role',
    headerName: 'Role',
    minWidth: 120,
    flex: 0.5,
    valueFormatter: ({value}) => {
      const role = adminRoles.find((role) => role.value === value);
      return role?.name || '';
    },
  },
  lastLogin: {
    field: 'user__lastLogin',
    headerName: 'Last Login',
    minWidth: 115,
    flex: 0.5,
    valueGetter: ({row}) =>
      row.user.lastLogin ? new Date(row.user.lastLogin) : null,
    valueFormatter: ({value}) =>
      value ? moment(value).format('MMM D, YYYY') : 'Never logged in',
  },
  ehr: {
    field: 'ehrId',
    headerName: 'EHR System',
    minWidth: 140,
    flex: 0.5,
    renderCell: ({row}) => {
      return row.data.ehr ? (
        <Typography>{row.data.ehr}</Typography>
      ) : (
        <Typography sx={{color: 'red.main', fontSize: 14, fontWeight: 'bold'}}>
          Not connected
        </Typography>
      );
    },
  },
  programs: {
    field: 'programs',
    headerName: 'Program',
    flex: 1,
    minWidth: 200,
    sortable: false,
    renderCell: ({row}) => {
      return <ProgramCell programs={row.programs || []} />;
    },
  },
  mobile: {
    field: 'mobile',
    headerName: '',
    minWidth: 150,
    flex: 1.5,
    renderCell: ({row}) => {
      return <StaffProfileCell staff={row} />;
    },
  },
  actions: {
    field: 'actions',
    headerName: 'Actions',
    type: 'actions',
    minWidth: 75,
    getActions: ({row}) => [<RemoveStaffButton key="remove" member={row} />],
  },
};
